
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import { Lead } from '@/types';

@Component
export default class LeadReopenDialog extends Vue {
  @Prop(Boolean) readonly value!: boolean;

  dialog = false
  loading = false

  @Watch('value')
  onValueChange(val: boolean) {
    console.log('LeadReopenDialog: onValueChange()'); // eslint-disable-line no-console

    this.dialog = val;
  }

  @Watch('dialog')
  onDialogChange(val: boolean) {
    if (this.value !== val) {
      this.$emit('input', val);
    }
  }

  get lead(): Lead {
    return this.$store.getters.currentLead;
  }

  async onCancel() {
    console.log('LeadReopenDialog: onCancel()'); // eslint-disable-line no-console

    this.dialog = false;
  }

  async onReopen() {
    console.log('LeadReopenDialog: onReopen()'); // eslint-disable-line no-console

    this.loading = true;

    await this.$store.dispatch('reopenLead');

    this.dialog = false;
    setTimeout(() => {
      this.loading = false;
    }, 500);
  }
}
